import React from 'react'
import styles from './styles.css'
import {withRouter, Link} from 'react-router'
import PropTypes from 'prop-types'

const links = [
  {title: 'Perfil', path: '/settings'},
  {title: 'Estado', path: '/settings/state'},
  {title: 'Mis firmas', onClick: () => global.openSignature()},
  {title: 'Firmas Digitales', path: '/settings/firmasDigitales'},
  {title: 'Contraseña', path: '/settings/password'},
  {title: 'Seguridad', path: '/settings/security'},
  
]

@withRouter
export default class Main extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    children: PropTypes.node
  }

  renderLinks() {
    return links.map((link, index) => {
      const isActive = this.props.router.location.pathname === link.path
      return (
        <div key={index} onClick={link.onClick} className={isActive ? 'active' : ''}>
          <Link to={link.path}>{link.title}</Link>
        </div>
      )
    })
  }
  

  render() {
    return (
      <div className={styles.container}>
        <div className="tabs">{this.renderLinks()}</div>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Settings/Layout/index.js